import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';



@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }


  getValue(val: string) {
    console.warn();
  }

  Images2 = [
    { title: "The Office of Strategy Management", text: "Why is there such a persistent gap between ambition and performance? The gap...", img: "assets/images/latest_article_img1.png" },
    { title: "Development Articles Programmer", text: "Hello guys, someone asks me another day, would you mind putting...", img: "assets/images/latest_article_img2.png" },
    { title: "How to Be Creative - A Year of Living Better Guides", text: "You know how you’ve got this image of the creator as a somewhat crazy, slightly...", img: "assets/images/latest_article_img3.png" },
    { title: "In publishing and graphic Lorem ipsum.", text: "Why is there such a persistent gap between ambition and performance? The gap...", img: "assets/images/latest_article_img4.png" },


  ];

  SlideOptions2 = {
    items: 4, margin: 10, dots: true, nav: true, mouseDrag: true, loop: true,
    touchDrag: true, pullDrag: true, autoplay: true, responsive: {
      0: {
        items: 1
      },
      300: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 4
      }


    },
  };

  Images1 = [

    { title: "In publishing and graphic Lorem ipsum.", text: "Hello guys, someone asks me another day, would you mind putting...", img: "assets/images/latest_article_img5.png" },
    { title: "In publishing and graphic Lorem ipsum.", text: "You know how you’ve got this image of the creator as a somewhat crazy, slightly...", img: "assets/images/latest_article_img6.png" },
    { title: "In publishing and graphic Lorem ipsum.", text: "Why is there such a persistent gap between ambition and performance? The gap...", img: "assets/images/latest_article_img7.png" },
    { title: "In publishing and graphic Lorem ipsum.", text: "Hello guys, someone asks me another day, would you mind putting...", img: "assets/images/latest_article_img8.png" },
    // { title: "In publishing and graphic Lorem ipsum.", text:"You know how you’ve got this image of the creator as a somewhat crazy, slightly...", img: "assets/images/latest_article_img9.png" },
    // { title: "The Office of Strategy Management", text:"Why is there such a persistent gap between ambition and performance? The gap...", img: "assets/images/latest_article_img1.png" },
    // { title: "Development Articles Programmer", text:"Hello guys, someone asks me another day, would you mind putting...", img: "assets/images/latest_article_img2.png" },
    // { title: "How to Be Creative - A Year of Living Better Guides", text:"You know how you’ve got this image of the creator as a somewhat crazy, slightly...", img: "assets/images/latest_article_img3.png" },

  ];

  SlideOptions1 = {
    items: 4, margin: 10, dots: true, nav: true, mouseDrag: true, loop: true,
    touchDrag: true, pullDrag: true, autoplay: true, responsive: {
      0: {
        items: 1
      },
      300: {
        items: 1
      },
      400: {
        items: 1
      },
      740: {
        items: 2
      },
      940: {
        items: 4
      }

      // 0: {
      //   items: 1
      // },
      // 400: {
      //   items: 2
      // },
      // 740: {
      //   items: 2
      // },
      // 940: {
      //   items: 3
      // }
    },
  };

  navigatecontact() {
    this.router.navigate(['contact']);
  }

}
